<template>
  <div>
    <v-card class="pa-2 mb-2">
      <v-toolbar
        :data-testid="`${source}-toolbar-title`"
        class="headline"
      >
        {{ title }}: {{ totals }}
      </v-toolbar>
    </v-card>
    <v-data-table
      :items="statistics"
      :headers="statHeaders"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [25, 50, 75, 100] }"
    />
  </div>
</template>

<script>
import { dashboardStatsHeaders } from "@/helpers/dashboard/dashboard-totals-data-table-headers";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    source: {
      type: String
    },
    statistics: {
      type: Array
    },
    title: {
      type: String
    },
    totals: {
      type: Number
    }
  },

  data() {
    return {
      statHeaders: dashboardStatsHeaders
    };
  }
};
</script>
